<template lang="pug">

  section.intro
    .container
      h1.logo
        img(src="assets/images/logo-208.png")
      h2.ana-tijoux
        img(src="assets/images/txt-ana-tijoux.png")
      h3.info
        img(src="assets/images/info.png")
      router-link(to="/trivia") Empezar

      img(src="assets/images/img-208.png")


</template>

<script>
  export default  {
    name: 'intro',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .logo{
    max-width: 400px;
    align-self: flex-start;
  }
  .ana-tijoux{
    align-self: center;
    max-width: 300px;
  }
  .info{
    align-self: flex-end;
    max-width: 300px;
  }
  .intro {
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url(../../../public/assets/images/bg-intro-2.jpg) no-repeat center top;
    background-size: cover;
  }
  h2{
    text-align: center;
  }
  .container{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    a{
      background: black;
      color: red;
      display: block;
      padding: 1rem 1.4rem 1rem 2rem;
      font-size: 1.6rem;
      max-width: 280px;
      text-transform: uppercase;
      letter-spacing: 1rem;
      text-align: center;
      margin: 2rem 0;
      border: 2px solid red;
    }
  }

</style>
